const getUpdatedValue = (changedValue, value) => changedValue || null;

const isMatch = (plot, value) => value === null || parseInt(value, 10) === 1 && plot.numberOfBedRooms === 1 || parseInt(value, 10) !== 1 && plot.numberOfBedRooms >= parseInt(value, 10);

const isSet = (value) => typeof value === 'string';

export default {
	getUpdatedValue,
	isMatch,
	isSet
};